import { render, staticRenderFns } from "./TeamStandings.vue?vue&type=template&id=3a6e4c84&"
import script from "./TeamStandings.vue?vue&type=script&lang=js&"
export * from "./TeamStandings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports